<template>
  <div class="mnp-porting-data">
    <SimonModal
      :is-visible="showPortingDataEndInfoModal"
      id="porting-data-end-info-modal"
      @hide="showPortingDataEndInfoModal = false"
    >
      <slot name="txtInfo"></slot>
    </SimonModal>
    <div class="form--block">
      <h2 class="h3">
        <slot name="txtHeadline"></slot>
      </h2>
      <MsisdnInputValidation
        name="portingDataMsisdn"
        ref="nestedInputPortingDataMsisdn"
        :msisdn.sync="portingDataMsisdn_"
        :invalid.sync="invalid.portingData.msisdn"
        :mandatory="true"
      >
        <template slot="lblInput"> <slot name="lblPhoneNumber"></slot></template>
        <template slot="txtInvalidLoginUser"><slot name="txtInvalidPhoneNumberError"></slot></template>
        <template slot="txtInvalidRequired"><slot name="txtInvalidRequiredError"></slot></template>
      </MsisdnInputValidation>

      <div>
        <LabeledRadioInput
          name="portingDataDateType"
          :model.sync="portingDataDateType_"
          :invalid.sync="invalid.portingData.dateType"
          ref="nestedInputportingDataDateType"
          first-radio-value="AS_SOON_AS_POSSIBLE"
          second-radio-value="CONTRACT_END"
          @change="portingDataConfirmation_ = false"
          :label="getSlotText('lblDateType')"
        >
          <template slot="afterLabel">
            <button type="button" aria-live="off" aria-haspopup="true" class="icon-only" @click="trackAndShowInfoModal()">
              <img src="files/flash/images/svg-icons/info-icon.svg" :alt="getSlotText('accessibilityInfoIconAlt')">
            </button>
          </template>
          <template slot="lblFirstOption">
            <slot name="lblDateTypeAsap"></slot>
          </template>
          <template slot="lblSecondOption">
            <slot name="lblDateTypeExpiration"></slot>
          </template>
        </LabeledRadioInput>
      </div>

      <div class="card card--info" v-if="portingDataDateType_ != ''">
        <LabeledCheckbox
          name="portingDataConfirmation"
          :model.sync="portingDataConfirmation_"
          :invalid.sync="invalid.portingData.confirmation"
          :mandatory="true"
          ref="nestedInputPortingDataConfirmation"
        >
          <template v-slot:txt>
            <slot name="txtProviderInformedAsap" v-if="portingDataDateType_ == 'AS_SOON_AS_POSSIBLE'"></slot>
            <slot name="txtProviderInformedExpiration" v-if="portingDataDateType_ == 'CONTRACT_END'"></slot>
          </template>

          <template v-slot:txtInvalidRequired>
            <slot name="txtInvalidRequiredError">Dies ist ein Pflichtfeld.</slot>
          </template>
        </LabeledCheckbox>
      </div>
    </div>
  </div>
</template>

<script>
import syncProperty from '@/mixins/syncProperty'
import { validationMixin } from 'vuelidate'
import validationFlow from '@/mixins/validators/validationFlow'
import SimonModal from '@/components/modal/SimonModal.vue'
import LabeledCheckbox from '@/components/forms/LabeledCheckbox.vue'
import MsisdnInputValidation from '@/components/generic/MsisdnInput.vue'
import LabeledRadioInput from '@/components/forms/LabeledRadioInput.vue'

export default {
  name: 'portingData',
  components: { LabeledRadioInput, MsisdnInputValidation, LabeledCheckbox, SimonModal },
  data () {
    return {
      showPortingDataEndInfoModal: false,
      invalid: {
        portingData: {
          dateType: null,
          msisdn: null,
          confirmation: null
        }
      }
    }
  },
  mixins: [
    validationMixin,
    syncProperty('portingDataMsisdn', 'portingDataMsisdn_'),
    syncProperty('portingDataDateType', 'portingDataDateType_'),
    syncProperty('portingDataConfirmation', 'portingDataConfirmation_'),
    validationFlow
  ],
  computed: {
    isFormInvalid: function () {
      return Object.entries(this.invalid.portingData)
        .map(([key, value]) => value)
        .some((value) => value === true)
    }
  },
  methods: {
    forceValidationOnNestedInputs () {
      Object.entries(this.$refs).forEach(([key, comp]) => {
        if (/^nestedInput/.test(key)) {
          comp.vflowForceFeedback()
        }
      })
    },
    trackAndShowInfoModal () {
      this.showPortingDataEndInfoModal = true
      const data = {
        information_action: 'reveal',
        information_name: 'mnp porting date info modal',
        information_ui_type: 'overlay',
        information_trigger: 'icon'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    }
  }
}
</script>
